import classNames from "classnames"
import { PropsWithChildren } from "react"
import * as React from "react"
import { Sizes } from "@oysterhr/common"

export type Headings = "h1" | "h2" | "h3" | "h4" | "h5"
export type HeadingSizes = Exclude<Sizes, "md" | "sm" | "xs">

interface HeadingProps extends PropsWithChildren<React.HTMLAttributes<HTMLHeadingElement>> {
  /**
   * @default h1
   * @param {Headings} as - The heading element to render
   * */
  as?: Headings
  /** @param {HeadingSizes} size - Overrides the default styling for the heading element defined in as prop */
  size?: HeadingSizes
}

export const mapTagsToStyles: Record<Headings, string> = {
  h1: "text-4xl leading-11 tracking-3xl",
  h2: "text-3xl leading-10 tracking-3xl",
  h3: "text-2xl leading-8 tracking-2xl",
  h4: "text-xl leading-8 tracking-xl",
  h5: "text-lg leading-6 tracking-lg",
}

const mapSizesToHeadingStyles: Record<HeadingSizes, Headings> = {
  "4xl": "h1",
  "3xl": "h2",
  "2xl": "h3",
  xl: "h4",
  lg: "h5",
}

export function Heading({
  as: Component = "h1",
  children,
  className,
  size,
  ...rest
}: HeadingProps) {
  const commonClassNames = "font-body text-black font-semibold"
  const cn = classNames(
    className,
    commonClassNames,
    mapTagsToStyles[mapSizesToHeadingStyles[size as HeadingSizes] || Component],
  )

  return (
    <Component className={cn} {...rest}>
      {children}
    </Component>
  )
}
